var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Home'),_c('VuexplosiveModal',{attrs:{"visible":_vm.showModal,"title":_vm.title,"content":_vm.content,"footer":_vm.footer}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }